import Enum from "../../../../../../enums/Enum";

const TypeEnum = new Enum({
        SPONTANEOUS: {name: "Spontaneous"},
        GUIDED: {name: "Guided"},
        FORCED: {name: "Forced"},
        OTHER: {name: "Other"}
});

export default TypeEnum;